import { render, staticRenderFns } from "./CadriPageTable.vue?vue&type=template&id=6ccc972d&scoped=true"
import script from "./CadriPageTable.vue?vue&type=script&lang=js"
export * from "./CadriPageTable.vue?vue&type=script&lang=js"
import style0 from "./CadriPageTable.vue?vue&type=style&index=0&id=6ccc972d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc972d",
  null
  
)

export default component.exports